export function isAdminFlow(): boolean {
  const url = window.location.href;
  return url.includes('staff');
}
